import { Entity, PrimaryGeneratedColumn, Column, CreateDateColumn } from 'typeorm'

@Entity('unit_twelve_excel_data')
export class UnitTweleveExcelDataEntity {

    @PrimaryGeneratedColumn('increment', {
        name: 'id',
    })
    id: number

    @Column('varchar', {
        nullable: false,
        length: 300,
        name: 'so_number'
    })
    soNumber: string;

    @Column('varchar', {
        nullable: false,
        length: 300,
        name: 'place_of_supply'
    })
    placeOfSupply: string;

    @Column('varchar', {
        nullable: false,
        length: 300,
        name: 'ship_to_customer'
    })
    shipToCustomer: string;

    @Column('varchar', {
        nullable: false,
        length: 300,
        name: 'customer_po'
    })
    customerPo: string;

    @Column('varchar', {
        nullable: false,
        length: 300,
        name: 'item_description'
    })
    itemDescription: string;

    @Column('varchar', {
        nullable: false,
        length: 300,
        name: 'hsn_code'
    })
    hsnCode: string;

    @Column('varchar', {
        nullable: false,
        length: 300,
        name: 'qty'
    })
    Qty: string;

    @Column('varchar', {
        nullable: false,
        length: 300,
        name: 'unit_price'
    })
    unitPrice: string;

    @Column('varchar', {
        nullable: false,
        length: 300,
        name: 'uom'
    })
    uom: string;

    @Column('varchar', {
        nullable: false,
        length: 300,
        name: 'net_amount'
    })
    netAmount: string;


    @Column('varchar', {
        nullable: false,
        length: 300,
        name: 'color'
    })
    color: string;

    @Column('varchar', {
        nullable: false,
        length: 300,
        name: 'size'
    })
    size: string;

    
    @Column('varchar', {
        nullable: false,
        length: 300,
        name: 'qty_wise_data'
    })
    qtyWiseData: string;

    @Column('varchar', {
        nullable: false,
        length: 300,
        name: 'tax'
    })
    tax: string;


    @Column("boolean", {
        nullable: false,
        default: true,
        name: "is_active"
    })
    isActive: boolean;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        length: 50
    })
    createdUser: string | null;


}